import { useTranslation } from 'react-i18next';

const interpolate = (template, values) =>
  String(template).replace(/{{\s*([^},]+).*?}}/g, (match, name) => {
    const value = values[name.trim()];
    return value === undefined || value === null ? match : String(value);
  });

/**
 * i18next is optional in parts of this application. When no resource owns a
 * key, react-i18next's fallback translator returns the key verbatim and does
 * not apply `defaultValue`. This wrapper keeps the normal i18next API while
 * guaranteeing that the supplied copy is what a reader sees.
 */
export default function useSafeTranslation() {
  const { t: translate, i18n } = useTranslation();

  const t = (key, options = {}) => {
    const { defaultValue = key, ...values } = options;
    const translated = translate(key, { defaultValue, ...values });

    return !translated || translated === key
      ? interpolate(defaultValue, values)
      : translated;
  };

  return { t, i18n };
}
